module.exports = __webpack_public_path__ + "static/media/b1.626c7f36.jpg";